import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import { Box, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import { Modal } from '../../../components/BootstrapToMUI';
import { useState } from 'react';
import { Autocomplete } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function GetInvoiceModal(props) {
  const theme = useTheme();
  const { isloading, setIsLoading, data, ...rest } = props;
  const [invoices, SetInvoices] = useState([]);
  const [select, setSelect] = useState('');
  const [pdf, setPdf] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    async function getInvoices() {
      console.log('123123', data);
      setIsLoading(false);
      await request({
        method: 'post',
        url: '/magex/getAllInvoice',
        data: { operator: data?.operator },
      })
        .then((res) => {
          if (!isCancelled) {
            console.log('res.data', res.data);
            setIsLoading(true);
            SetInvoices(res.data);
          }
        })
        .catch((err) => {
          Swal.fire({
            icon: 'info',
            title: 'Oops...',
            text: `There is no files for this operator or something went wrong`,
          });
          props.onHide();
          setIsLoading(true);
        });
    }

    if (props.show) {
      getInvoices();
    }

    return () => {
      setSelect('');
      isCancelled = true;
    };
  }, [props.show]);

  const downloadInvoice = async (send) => {
    console.log('send', send);
    setIsLoading(false);
    await request({
      method: 'post',
      url: '/magex/downloadInvoiceFromDisk',
      data: { operator: data?.operator, filename: select, send: send, email: data?.email },
      responseType: 'blob',
    })
      .then(async (res) => {
        console.log('send', send);
        if (!send) {
          console.log('2123');
          const pdfData = await res.data;
          setPdf(pdfData);
          setIsLoading(true);
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: `The invoice has been sent to ${data?.email}`,
          });
          setIsLoading(true);
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: `There is no files for this operator or something went wrong`,
        });
        setIsLoading(true);
      });
  };

  const deleteInvoice = async () => {
    setIsLoading(false);
    await request({
      method: 'delete',
      url: '/magex/deleteInvoice',
      data: { operator: data?.operator, filename: select },
    })
      .then((res) => {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: `The invoice has been deleted`,
        });
        setIsLoading(true);
        props.onHide();
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: `There is no files for this operator or something went wrong`,
        });
        setIsLoading(true);
      });
  };

  useEffect(() => {
    if (pdf) {
      const url = window.URL.createObjectURL(new Blob([pdf]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'invoice.pdf');
      document.body.appendChild(link);
      link.click();
    }
  }, [pdf]);

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" sx={{ fontSize: '1.2rem' }}>
          Get Invoices
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          <Box sx={{ display: 'flex', mt: 4, mb: 4 }}>
            <Autocomplete
              value={select}
              onChange={(event, newValue) => {
                setSelect(newValue);
              }}
              options={invoices}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Invoice"
                  variant="outlined"
                  sx={{ width: '350px', mr: 6.25 }}
                />
              )}
            />
            <Button
              variant="contained"
              onClick={() => {
                downloadInvoice(false);
              }}
              sx={{ mr: 3.75 }}
            >
              Download
            </Button>
            <Button
              sx={{ mr: 3.75 }}
              variant="contained"
              onClick={() => {
                downloadInvoice(true);
              }}
            >
              Send
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                deleteInvoice();
              }}
            >
              Delete
            </Button>
          </Box>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
